export const ApiResponse = {
    status: {
        success :'Success',
        error: 'Error'
    } 
} 